import { getFetch } from "../../utils/fetch";

async function getMachineType(term) {
  const data = await getFetch(`/ReportWeb/MachineType?term=${term}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

export { getMachineType };
